import * as bootstrap from '@/node_modules/bootstrap/js/index.esm.js'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('bootstrap', bootstrap)
})
